
import { Component, Prop, Watch } from 'vue-property-decorator'
import Swiper, { SwiperOptions } from 'swiper'
import ImageCarousel from './image-carousel.vue'

@Component({
  template: `
  <article
    class='image-carousel image-carousel-for-product'
    :class='{"show-enlargement": showEnlargement, "single-image": assetList && assetList.length === 1}' v-click-outside='closeEnlargement'>

    <swiper
      class='swiper top ignore-mobile-menu-swipe swiper-top-product'
      :options='swiperOptionsTopForProduct'
      ref='swiperTop'>
      <template>
        <swiper-slide v-for='(item,index) in assetList' v-show='item.url != ""' :key="index">
            <img @click='openEnlargement' :alt='item.title' :src='item.url + "?width=920&height=920&mode=Min&format=webp"' />
        </swiper-slide>
    </template>
      <i @click.stop='openEnlargement' class='icons8-expand white--text hidden-phablet-p'></i>
        <div v-show='assetList && assetList.length > 1 && !showEnlargement' class='swiper-index-text'>{{ activeIndex }} {{ divider }} {{ activeIndex }}</div>
    </swiper>

    <button v-show='showEnlargement' class='close-button' @click.stop='closeEnlargement'>
    <i class='icons8-delete'></i>
    </button>

    <template v-show='assetList && assetList.length > 1'>
      <div :class='[{"in-overlay": showEnlargement, "is-desktop": !isPhone }, buttonClass("prev")]' slot='button-prev'></div>
      <div :class='[{"in-overlay": showEnlargement, "is-desktop": !isPhone}, buttonClass("next")]' slot='button-next'></div>
    </template>

    <template v-show='assetList && assetList.length > 1'>
        <swiper class='swiper product-thumbs hidden-phone' :options='swiperOptionsThumbsProduct' v-show='assetList && assetList.length > 1' ref='swiperThumbs'>
            <template v-for="(item,index) in assetList">
                <swiper-slide class="swiper__thumbs--product" v-show='item.url != ""' :class='{"active-thumb": swiperTop?.activeIndex === index}'>
                    <img @click='swiperTop.slideTo(index)' :src='item.url + "?width=920&height=920&mode=Min&format=webp"' :alt='item.title' />
                </swiper-slide>
            </template>
        </swiper>
    </template>
  </article>
`
})

export default class ImageCarouselForProductBe extends ImageCarousel {
  @Prop({default: ''}) sliderName!: string
  @Prop({default: ''}) assets!: any
  @Prop({default: ''}) divider: string
  @Prop({default: ''}) dimensionDrawing: boolean

  swiperTop: Swiper | null = null

  prevButton = ''
  nextButton = ''


  swiperOptionsThumbsProduct: SwiperOptions = {
    spaceBetween: 20,
    observer: true,
    observeParents: true,
    slidesPerView: 'auto',
    freeMode: true,
    speed: 500,
    on: {
      slideChange: this.onSlideChange
    }
  }

    swiperOptionsTopForProduct: SwiperOptions = {
      grabCursor: true,
      observer: true,
      observeParents: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      navigation: {
        nextEl: '.top.swiper-next--' + this.sliderName,
        prevEl: '.top.swiper-prev--' + this.sliderName
      },
      speed: 500,
      on: {
        slideChange: this.onSlideChange
      }
    }

    get assetList(): void {
      return this.assets
    }

    buttonClass(value: string): string {
      return `swiper-button-${value} top swiper-${value}--${this.sliderName}`
    }

    goToSlide(index: number): void {
      if (this.thumbSwiper && this.swiperTop) this.swiperTop.slideTo(index)
    }


    @Watch('amountOfImages')
    onValueChanged(value: number): void {
      this.amountOfImages = value

      this.$nextTick(() => {
        if (this.amountOfImages > 1) {
          const thumbSwiper = (this.$refs.swiperThumbs as any).$swiper as Swiper
          const swiperTop = (this.$refs.swiperTop as any).$swiper as Swiper
          this.swiperTop = swiperTop
          this.thumbSwiper = thumbSwiper
        }
      })
    }
}
